import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginUser } from '../../model/login-user';
import { LoginWizardService } from '../../services/wizard/login/login.wizard.service';
import { NotificationToastService } from '../../services/notification-toast.service';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'app-component-login',
  templateUrl: './component.login.html',
  styleUrls: ['./component.login.css']
})

// tslint:disable-next-line: component-class-suffix
export class ComponentLogin implements OnInit {

  public loginForm: FormGroup;
  public loading = false;
  errorMessage = '';
  returnUrl = '';

  constructor(private notificationToastService: NotificationToastService
    , private menuService: MenuService
    , private formBuilder: FormBuilder
    , private activatedRoute: ActivatedRoute
    , private loginWizardService: LoginWizardService) {
    this.menuService.setMenuTitle('', '');
  }

  ngOnInit(): void {
    this.returnUrl = this.activatedRoute.snapshot.params.returnUrl;
    this.loginForm = this.formBuilder.group({
      userName: ['', Validators.required],
      userPassword: ['', Validators.required],
    });
  }

  get f() { return this.loginForm.controls; }

  async login() {
    try {
      this.loading = true;
      this.errorMessage = '';

      if (this.loginForm.invalid) {
        return;
      }

      await this.loginWizardService
        .login(this.loginForm.value.userName,
          this.loginForm.value.userPassword,
          this.returnUrl);

    } catch (err) {
      this.errorMessage = err.error;
    } finally {
      this.loading = false;
    }

  }
}
